import { replace } from 'connected-react-router';
import config from 'react-global-configuration';
import { setLanguage } from '../UI';
import { getLanguageByPath } from '../../../helpers';
import { nodeGetLoaded } from './Node';
import { referenceLoadingDone, referenceLoadingReset, referenceLoadingStart } from '../UI/ReferenceLoading';
import { taxonomyTermGetLoaded } from './TaxonomyTerm';
import { userGetLoaded } from './User';
import { webformGetLoaded } from './Webform';
import { profileGetLoaded } from './Profile';
export var ENTITY_LOADING_STATUS_START = 'entity-loading-status-start-delayed';
export var ENTITY_LOADING_STATUS_LOADING = 'entity-loading-status-loading';
export var ENTITY_LOADING_STATUS_LOADED = 'entity-loading-status-loaded';
export var ENTITY_LOADING_STATUS_ERROR = 'entity-loading-status-error';
export function entityGetByPath(path) {
  return function (dispatch, getState) {
    // We have two delays: one delay and one duration (speed).
    var transitionOffset = config.get('PAGE_TRANSITION_DELAY', 0);
    var transitionDelay = config.get('PAGE_TRANSITION_SPEED', 0);
    dispatch(referenceLoadingReset());
    dispatch(referenceLoadingStart());
    dispatch(entityLoadStart());

    // Wait for initial offset.
    setTimeout(function () {
      dispatch(entityLoading());
      var startTime = new Date();
      var language = getLanguageByPath(path);
      dispatch(setLanguage(language));
      var MULTILINGUAL = config.get('MULTILINGUAL', true);
      var API_URL = config.get('API_URL', '');
      var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
      var credentials = getState().getIn(['ui', 'fetch', 'credentials', 'content'], 'include');
      var headers = getState().getIn(['ui', 'fetch', 'headers', 'content']);
      fetch("".concat(PATH, "/router/translate-path?path=").concat(path, "&_format=json"), {
        credentials: credentials,
        headers: headers
      }).then(function (response) {
        // Delay the transition with the original speed minus the time it took
        // this call to be processed.
        var endTime = new Date();
        var timeDiff = endTime - startTime;
        setTimeout(function () {
          parseEntityResponse(response, dispatch);
        }, Math.max(0, transitionDelay - timeDiff));
      }).catch(function (e) {
        dispatch(entityStatus(503));
        return dispatch(entityNotFound());
      });
    }, transitionOffset);
  };
}
function parseEntityResponse(response, dispatch) {
  var API_URL = config.get('API_URL', '');
  if (!response.ok) {
    console.error('Response not OK', response);
  }
  if (response.status !== 200) {
    dispatch(entityStatus(response.status));
    dispatch(entityNotFound());
    return;
  }
  dispatch(entityStatus(response.status));
  return response.json().then(function (response) {
    if (response.redirect) {
      if (response.redirect[0].to.match(/^http/)) {
        return window.location.href = response.redirect[0].to;
      }
      return dispatch(replace(response.redirect[0].to));
    }
    if (response.entity) {
      var canonical = response.entity.canonical.replace(API_URL, '');
      dispatch(entityLoaded(response.entity.type, response.entity.id, canonical));
      if (response.entity.entity) {
        switch (response.entity.type) {
          case 'node':
            dispatch(nodeGetLoaded(response.entity.id, response.entity.entity));
            break;
          case 'user':
            dispatch(userGetLoaded(response.entity.id, response.entity.entity));
            break;
          case 'taxonomy_term':
            dispatch(taxonomyTermGetLoaded(response.entity.id, response.entity.entity));
            break;
          case 'profile':
            dispatch(profileGetLoaded(response.entity.id, response.entity.entity));
            break;
          case 'webform':
            dispatch(webformGetLoaded(response.entity.id, response.entity.entity));
            break;
          default:
            break;
        }
        dispatch(referenceLoadingDone());
      }
    }
    if (response.breadcrumbs) {
      dispatch(breadcrumbsLoaded(response.breadcrumbs));
    }
  });
}
export var ENTITY_LOAD_START = 'ENTITY_LOAD_START';
export function entityLoadStart() {
  return {
    type: ENTITY_LOAD_START
  };
}
export var ENTITY_LOADING = 'ENTITY_LOADING';
export function entityLoading() {
  return {
    type: ENTITY_LOADING
  };
}
export var ENTITY_RESET = 'ENTITY_RESET';
export function entityReset() {
  return {
    type: ENTITY_RESET
  };
}
export var ENTITY_LOADED = 'ENTITY_LOADED';
export function entityLoaded(entityType, entityId, canonical) {
  return {
    type: ENTITY_LOADED,
    entityType: entityType,
    entityId: entityId,
    canonical: canonical
  };
}
export var ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND';
export function entityNotFound() {
  return {
    type: ENTITY_NOT_FOUND
  };
}
export var ENTITY_STATUS = 'ENTITY_STATUS';
export function entityStatus(status) {
  return {
    type: ENTITY_STATUS,
    status: status
  };
}
export var BREADCRUMBS_LOADED = 'BREADCRUMBS_LOADED';
export var breadcrumbsLoaded = function breadcrumbsLoaded(breadcrumbs) {
  return {
    type: BREADCRUMBS_LOADED,
    payload: breadcrumbs
  };
};